export const muiFormControlOverrides = {
	styleOverrides: {
		root: ({ theme }) => {
			return {
				width: '100%',
				padding: `0 ${theme.tsGoUnit.tsUnitHalf}`,
			};
		},
	},
};
